import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        component: () => import('@/components/base/LandingBase'),
        children: [
            {
                path: 'home',
                component: () => import('@/views/landing/IndexView'),
            },
            {
                path: 'products/:productId',
                name: 'product',
                component: () => import('@/views/landing/ProductView'),
                meta: {
                    breadcrumb: [
                        {name: 'خانه', link: '/'},
                        {name: 'محصول'}
                    ]
                }
            },
            {
                path: 'table',
                component: () => import('@/views/landing/TableView'),
            },
        ]
    },
    {
        path: '/auth',
        component: () => import('@/components/base/GuestBase'),
        children: [
            {
                path: 'login',
                component: () => import('@/views/auth/LoginView'),
                alias: '/login'
            },
        ]
    },
    {
        path: '/panel',
        component: () => import('@/components/base/PanelBase'),
        children: [
            {
                path: 'about',
                component: () => import('@/views/AboutView'),
            },
            {
                path: 'home',
                name: 'home',
                component: () => import('@/views/PanelView.vue'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان'}
                    ]
                }
            },
            {
                path: 'admin/students',
                name: 'studentList',
                component: () => import('@/views/admin/StudentListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست دانش‌آموزان'}
                    ]
                }
            },
            {
                path: 'admin/students/:studentId',
                name: 'adminProfile',
                component: () => import('@/views/admin/ProfileView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست دانش‌آموزان', link: 'panel/admin/students'},
                        {name: 'اطلاعات کاربری'},
                    ]
                }
            },
            {
                path: 'admin/owners',
                name: 'ownerList',
                component: () => import('@/views/admin/OwnerListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست مدیران'}
                    ]
                }
            },
            {
                path: 'admin/teachers',
                name: 'teacherList',
                component: () => import('@/views/admin/TeacherListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست اساتید'}
                    ]
                }
            },
            {
                path: 'admin/consultants',
                name: 'consultantList',
                component: () => import('@/views/admin/ConsultantListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست مشاوران'}
                    ]
                }
            },
            {
                path: 'admin/reviewers',
                name: 'reviewerList',
                component: () => import('@/views/admin/ReviewerListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست ویراستاران'}
                    ]
                }
            },
            {
                path: 'admin/schools',
                name: 'schoolList',
                component: () => import('@/views/admin/SchoolListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست مدارس'}
                    ]
                }
            },
            {
                path: 'classes',
                name: 'classList',
                component: () => import('@/views/student/ClassListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'کلاس‌ها'}
                    ]
                }
            },
            {
                path: 'analysis',
                name: 'analysisList',
                component: () => import('@/views/student/AnalysisListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'تحلیل‌ها'}
                    ]
                }
            },
            {
                path: 'admin/classes',
                name: 'adminClassList',
                component: () => import('@/views/admin/ClassListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست کلاس‌ها'}
                    ]
                }
            },
            {
                path: 'admin/licenses',
                name: 'adminLicenseList',
                component: () => import('@/views/admin/LicenseListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست لایسنس‌ها'}
                    ]
                }
            },
            {
                path: 'license',
                name: 'License',
                component: () => import('@/views/student/LicenseView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لایسنس'}
                    ]
                }
            },
            {
                path: 'admin/courses',
                name: 'adminCourseList',
                component: () => import('@/views/admin/CourseListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست دروس'}
                    ]
                }
            },
            {
                path: 'admin/groups/create',
                name: 'adminGroupCreate',
                component: () => import('@/views/GroupCreateView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'ایجاد گروه'}
                    ]
                }
            },
            {
                path: 'admin/classes/:classId/sessions',
                name: 'adminSessionList',
                component: () => import('@/views/admin/SessionListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست کلاس‌ها', link: 'panel/admin/classes'},
                        {name: 'لیست جلسات'}
                    ]
                }
            },
            {
                path: 'classes/:classId/sessions',
                name: 'sessionList',
                component: () => import('@/views/student/SessionListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'کلاس‌ها', link: 'panel/classes'},
                        {name: 'جلسات'}
                    ]
                }
            },
            {
                path: 'classes/:classId/sessions/:sessionId',
                name: 'session',
                component: () => import('@/views/student/SessionView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'کلاس‌ها', link: 'panel/classes'},
                        {name: 'جلسات', link: 'panel/classes/:classId/sessions'},
                        {name: 'جلسه'}
                    ]
                }
            },
            {
                path: 'admin/classes/:classId/sessions/:sessionId/homeworks',
                component: () => import('@/views/admin/HomeworkListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست کلاس‌ها', link: 'panel/admin/classes'},
                        {name: 'لیست جلسات', link: 'panel/admin/classes/:classId/sessions'},
                        {name: 'لیست تکالیف'}
                    ]
                }
            },
            {
                path: 'admin/classes/:classId/projects',
                component: () => import('@/views/admin/ProjectListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست کلاس‌ها', link: 'panel/admin/classes'},
                        {name: 'لیست پروژه‌ها'}
                    ]
                }
            },
            {
                path: 'classes/:classId/sessions/:sessionId/homeworks',
                component: () => import('@/views/student/HomeworkListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'کلاس‌ها', link: 'panel/classes'},
                        {name: 'جلسات', link: 'panel/classes/:classId/sessions'},
                        {name: 'تکالیف'}
                    ]
                }
            },
            {
                path: 'admin/exams',
                name: 'adminExamList',
                component: () => import('@/views/admin/ExamListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها'}
                    ]
                }
            },
            {
                path: 'admin/bank/questions',
                name: 'adminBankQuestions',
                component: () => import('@/views/admin/BankQuestionsView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'سؤالات بانک سؤال'}
                    ]
                }
            },
            {
                path: 'admin/bank/labels',
                name: 'adminBankLabels',
                component: () => import('@/views/admin/BankLabelsView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'دسته‌بندی بانک سؤال'}
                    ]
                }
            },
            {
                path: 'admin/bank/reviewers',
                name: 'adminBankReviewers',
                component: () => import('@/views/admin/BankReviewerView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'ویراستاران بانک سؤال'}
                    ]
                }
            },
            {
                path: 'admin/bank/reviewers/:reviewerId/audit-logs',
                name: 'adminReviewerAuditLog',
                component: () => import('@/views/admin/ReviewerAuditLogListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'ویراستاران بانک سؤال', link: 'panel/admin/bank/reviewers'},
                        {name: 'فعالیت‌ها'}
                    ]
                }
            },
            {
                path: 'admin/bank/audit-logs',
                name: 'adminBankAuditLogs',
                component: () => import('@/views/admin/BankAuditLogListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'بانک سؤال'},
                        {name: 'فعالیت‌ها'}
                    ]
                }
            },
            {
                path: 'admin/exams/create',
                name: 'adminExamCreate',
                component: () => import('@/views/admin/ExamCreateView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'ایجاد آزمون‌'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId',
                name: 'adminExamUpdate',
                component: () => import('@/views/admin/ExamUpdateView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'ویرایش آزمون‌'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId/results',
                name: 'adminExamResultList',
                component: () => import('@/views/admin/ExamResultListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'لیست نتایج'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId/results/:resultId',
                name: 'adminExamResult',
                component: () => import('@/views/admin/ExamResultView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'لیست نتایج', link: 'panel/admin/exams/:examId/results'},
                        {name: 'پاسخ دانش‌آموز'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId/corrections/:resultId',
                component: () => import('@/views/admin/ExamCorrectionView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'لیست نتایج', link: 'panel/admin/exams/:examId/results'},
                        {name: 'تصحیح'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId/question',
                name: 'adminExamQuestion',
                component: () => import('@/views/admin/QuestionListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'لیست سؤالات'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId/preview',
                name: 'adminExamPreview',
                component: () => import('@/views/admin/ExamPreview'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'پیش نمایش آزمون'}
                    ]
                }
            },
            {
                path: 'admin/exams/:examId/print',
                name: 'adminExamPrint',
                component: () => import('@/views/admin/ExamPrintView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست آزمون‌ها', link: 'panel/admin/exams'},
                        {name: 'پرینت آزمون'}
                    ]
                }
            },
            {
                path: 'exams/available',
                name: 'examAvailableList',
                component: () => import('@/views/student/ExamListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'آزمون‌های فعال'}
                    ]
                }
            },
            {
                path: 'exams/participated',
                name: 'examParticipatedList',
                component: () => import('@/views/student/ExamParticipatedListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'آزمون‌های اخیر'}
                    ]
                }
            },
            {
                path: 'exams/:examId/participated/interactions',
                name: 'examInteraction',
                component: () => import('@/views/student/ExamInteractionView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'آزمون‌های اخیر', link: 'panel/exams/participated'},
                        {name: 'پاسخ‌های من'}
                    ]
                }
            },
            {
                path: 'exams/:examId/participated/result',
                name: 'examResult',
                component: () => import('@/views/student/ExamResultView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'آزمون‌های اخیر', link: 'panel/exams/participated'},
                        {name: 'کارنامه'}
                    ]
                }
            },
            {
                path: 'exams/:examId/participation',
                name: 'interExam',
                component: () => import('@/views/ExamPageView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'آزمون‌های فعال', link: 'panel/exams/available'},
                        {name: 'برگزاری آزمون'}
                    ]
                }
            },
            {
                path: 'admin/shop/products',
                name: 'adminProducts',
                component: () => import('@/views/admin/ProductListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست محصولات‌'}
                    ]
                }
            },
            {
                path: 'admin/shop/categories',
                name: 'adminShopCategories',
                component: () => import('@/views/admin/ShopCategoryListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست دسته‌بندی محصولات‌'}
                    ]
                }
            },
            {
                path: 'admin/consultations',
                name: 'adminConsultations',
                component: () => import('@/views/admin/ConsultationListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست مشاوره‌ها'}
                    ]
                }
            },
            {
                path: 'admin/consultations/:consultationId/schedules',
                name: 'adminConsultationSchedules',
                component: () => import('@/views/admin/ConsultationSchedulesView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست مشاوره‌ها', link: 'panel/admin/consultations'},
                        {name: 'لیست زمان‌بندی‌‌ها'}
                    ]
                }
            },
            {
                path: 'admin/users/:userId/consultations/sessions',
                name: 'adminConsultationSessions',
                component: () => import('@/views/admin/ConsultationSessionsView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست دانش‌آموزان', link: 'panel/admin/users'},
                        {name: 'جلسات مشاوره'}
                    ]
                }
            },
            {
                path: 'admin/users/:userId/consultations/exams',
                name: 'adminConsultationExams',
                component: () => import('@/views/admin/ConsultationExamsView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'لیست دانش‌آموزان', link: 'panel/admin/users'},
                        {name: 'نتایج آزمون'}
                    ]
                }
            },
            {
                path: 'chats/conversations',
                name: 'chats',
                component: () => import('@/views/chat/ChatView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'گفتگو‌ها'},
                    ]
                },
                children: [
                    {
                        path: ':conversationId',
                        name: 'conversation',
                        component: () => import('@/components/pages/chat/conversationView/MainCard'),
                    }
                ]
            },
            {
                path: 'consultations',
                name: 'consultations',
                component: () => import('@/views/student/ConsultationListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'مشاوره‌ها'}
                    ]
                }
            },
            {
                path: 'consultations/:consultationId/schedules',
                name: 'consultationSchedules',
                component: () => import('@/views/student/ConsultationSchedulesView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'مشاوره‌ها', link: 'panel/consultations'},
                        {name: 'زمان‌بندی‌‌ها'}
                    ]
                }
            },
            {
                path: 'tickets',
                name: 'tickets',
                component: () => import('@/views/ticket/TicketListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'درخواست‌ها'},
                    ]
                }
            },
            {
                path: 'tickets/:ticketId/sub-tickets',
                name: 'subTicket',
                component: () => import('@/views/ticket/SubTicketListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'درخواست‌ها', link: 'panel/tickets'},
                        {name: 'جزئیات درخواست'},
                    ]
                },
            },
            {
                path: 'profile',
                name: 'profile',
                component: () => import('@/views/student/ProfileView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'اطلاعات کاربری'},
                    ]
                }
            },
            {
                path: 'orders',
                name: 'orders',
                component: () => import('@/views/student/OrderListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'تراکنش‌ها'},
                    ]
                }
            },
            {
                path: 'products',
                name: 'products',
                component: () => import('@/views/student/ProductListView'),
                meta: {
                    breadcrumb: [
                        {name: 'پیشخوان', link: 'panel/home'},
                        {name: 'فروشگاه'},
                    ]
                }
            },
        ]
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.path === '/') {
        next('/home')
    }

    const publicPages = ['/login', '/home', '/table', `/products/${to.params.productId}`];
    const authRequired = !publicPages.includes(to.path);
    const authPersistent = JSON.parse(localStorage.getItem('authPersistent'));
    const loggedIn = authPersistent?.loggedIn ?? false;
    // trying to access a restricted page + not logged in
    // redirect to login page
    if (authRequired && !loggedIn) {
        next('/login');
    } else {
        next();
    }
});

router.afterEach((to) => {
    for (const breadcrumb of to.meta?.breadcrumb) {
        if (!breadcrumb?.link) return;

        if (breadcrumb?.link.includes(":examId")) {
            breadcrumb.link = breadcrumb?.link.replace(":examId", to.params?.examId)
        }

        if (breadcrumb.link.includes(":classId")) {
            breadcrumb.link = breadcrumb?.link.replace(":classId", to.params?.classId)
        }

        if (breadcrumb.link.includes(":sessionId")) {
            breadcrumb.link = breadcrumb?.link.replace(":sessionId", to.params?.sessionId)
        }

        if (breadcrumb.link.includes(":productId")) {
            breadcrumb.link = breadcrumb?.link.replace(":productId", to.params?.productId)
        }

        if (breadcrumb.link.includes(":labelId")) {
            breadcrumb.link = breadcrumb?.link.replace(":labelId", to.params?.labelId)
        }

        if (breadcrumb.link.includes(":questionId")) {
            breadcrumb.link = breadcrumb?.link.replace(":questionId", to.params?.questionId)
        }

        if (breadcrumb.link.includes(":consultationId")) {
            breadcrumb.link = breadcrumb?.link.replace(":consultationId", to.params?.consultationId)
        }
    }
});

export default router
